<template>
  <div class="p-2">
    <div
      v-for="(data,index) in metadata"
      :key="`${data.key}-${index}`"
      class="d-flex align-items-start mb-1 flex-column flex-sm-row align-items-sm-center"
    >
      <span class="text-secondary mr-1">
        {{ data.key }}:
      </span>
      <span :class="data.value ? 'text-main' : 'text-secondary font-italic text-sm'">
        {{ data.value || 'empty' }}
      </span>
    </div>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  name: 'FileVersionMetadata',
  mixins: [helpers],
  props: {
    viewingVersionId: {
      type: String,
      default: null,
      required: true,
    },
    versionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    metadata() {
      const customPairObj = this.versionData.metadata
      const customPairArr = Object.keys(customPairObj).map(key => ({ key: key.replace('x-amz-meta-', ''), value: customPairObj[key] }))

      const arr = []
      arr.push({ key: 'Content-Type', value: this.versionData.contentType })
      arr.push({ key: 'Cache-Control', value: this.versionData.cacheControl })
      arr.push({ key: 'Content-Encoding', value: this.versionData.contentEncoding })
      arr.push({ key: 'Content-Disposition', value: this.versionData.contentDisposition })

      return [...arr, ...customPairArr]
    },
  },
}
</script>

<style>

</style>
